/**
 * iOS Video Fix
 *
 * iOS Safari requires playsInline + muted on <video> for inline playback.
 * LiveKit's VideoTrack doesn't set these, so we patch the DOM element directly.
 *
 * Shared across screen-stream-viewer and video-panel.
 */

import { useEffect } from 'react'

export function IosVideoFix({ containerRef }: { containerRef: React.RefObject<HTMLDivElement | null> }) {
	useEffect(() => {
		const container = containerRef.current
		if (!container) return

		const applyAttributes = () => {
			const videos = container.querySelectorAll('video')
			for (const video of videos) {
				video.playsInline = true
				video.setAttribute('playsinline', '')
				video.setAttribute('webkit-playsinline', '')
				video.muted = true
			}
		}

		applyAttributes()
		const observer = new MutationObserver(applyAttributes)
		observer.observe(container, { childList: true, subtree: true })

		return () => observer.disconnect()
	}, [containerRef])

	return null
}
